export const LOGO = '/visto_logo.svg';
